<template>
	<div id="app">
		<div class="menu">
			<components-menu :menu="menu" :collapse="collapse"/>
		</div>
		<div class="app-content">
			<div class="app-header">
				<components-header :collapse="collapse" @toggleCollapse="toggleCollapse"/>
			</div>
			<div class="app-container">
				<div class="app-tags">
					<components-tags/>
				</div>
				<div class="content">
					<transition name="fade">
						<router-view :key="route_key"></router-view>
					</transition>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ComponentsHeader from "@/components/layout/admin/Header.vue"
import ComponentsMenu from "@/components/layout/admin/Menu.vue"
import ComponentsTags from "@/components/layout/admin/Tags.vue"
import {auth} from "@/api/admin";
import {site_config} from "@/config";
export default {
	middleware:['admin'],
	components:{ComponentsHeader,ComponentsTags,ComponentsMenu},
	data(){
		return {
			collapse:false,
			menu:[
				{title:"控制台", icon:'el-icon-odometer', path:'/admin'},
				{title:"嘉宾管理", icon:'el-icon-tickets',path:'/admin/speaker'},
				{title:"日程管理", icon:'el-icon-tickets',path:'/admin/plan'},
				{title:"产品介绍", icon:'el-icon-tickets',path:'/admin/video'},
				{title:"白皮书下载", icon:'el-icon-tickets',path:'/admin/file'},
				{title:"管理员",icon:'el-icon-user',path:'/admin/admin'},
			]
		}
	},
	computed:{
		route_key(){
			return this.$route.fullPath
		},
		meta(){
			return this.$route.meta;
		}
	},
	watch:{
		$route(){
			this.$store.commit('admin/setError',{})
		}
	},
	mounted() {
		document.title = `${site_config.title}CMS管理系统`
		this.getAdminInfo();
	},
	methods:{
		toggleCollapse(){
			this.collapse = !this.collapse;
		},
		getAdminInfo(){
			auth.getLoginInfo().then((res)=>{
				this.$store.commit('admin/setAdminInfo',res.admin)
			})
		}
	}
}
</script>

<style lang="scss">
@import '@/assets/admin/css/reset.scss';
@import '@/assets/admin/css/ricktext.scss';
</style>
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {transition: all .3s ease;}
.fade-enter-from, .fade-leave-to {opacity: 0;transition: all .3s ease;}
#app{position: relative;min-height: 100vh;display: flex;
	.app-content{flex: 1;overflow: hidden;
		.app-tags{margin-bottom: 15px;}
		.app-container{padding: 15px;background: #efefef;height:calc(100vh - 56px);overflow: hidden;overflow-y: auto;
			.content{background: #fff;padding: 15px;}
		}
	}
}
</style>
